import Vue from "vue";

const store = () => window.$store;
const { fb, fbBase, fbusersbase, storage } = require('../util').default.fb();
const f = false;
async function deleteAction(state, payload) {
  const st = store().state;
  // TODO proper deindexing
  console.log("deleting from payload", payload);
  const methods = {
    comments: (payload) => {
      var commentRef = fbBase
        .collection(payload.type)
        .doc(payload["commentsid"]);
      commentRef.update({ [payload.id]: fb.firestore.FieldValue.delete() });
      if (st.comments && st.comments[payload["commentsid"]]) {
        Vue.delete(st.comments[payload["commentsid"]], payload.id);
      }
    },
    reputation: (payload) => {
      var repRef = fbBase.collection(payload.type).doc(payload.id);
      repRef.update({ [payload.rid]: fb.firestore.FieldValue.delete() });
      if (st.reputation && st.reputation[payload.id]) {
        Vue.delete(st.reputation[payload.id], payload.rid);
      }
      if (
        st.user &&
        st.user[store().state.auth.uid] &&
        st.user[store().state.auth.uid].userreps
      ) {
        Vue.delete(st.user[store().state.auth.uid].userreps, payload.id);
      }
      store().dispatch("update", {
        type: "user",
        id: store().state.auth.uid,
        data: st.user[store().state.auth.uid],
      });
      var tRef = fbBase
        .collection("reputation")
        .doc(payload.id)
        .collection("meta")
        .doc("stats");
      return fb.firestore().runTransaction(function (t) {
        return t.get(tRef).then(function (sfDoc) {
          if (!sfDoc.exists) return;
          var newCount = sfDoc.data().count - 1;
          var totalQuality = Number(sfDoc.data().quality) - 5;
          return t.set(
            tRef,
            { count: newCount, quality: totalQuality },
            { merge: f }
          );
        });
      });
    },
    files: (payload) => {
      const ref = storage
        .ref()
        .child(payload.user)
        .child(payload.hash)
        .child(payload.name);
      let after = () =>
        fbusersbase
          .collection(store().state.auth.uid)
          .doc("files")
          .update({ [payload.hash]: fb.firestore.FieldValue.delete() });
      ref.delete().then(after()).catch(after());
    },
    keys: (payload) => {
      fbusersbase
        .collection(store().state.auth.uid)
        .doc("keys")
        .update({ [payload.hash]: fb.firestore.FieldValue.delete() });
    },
    msgs: async (payload) => {
      const s = store().state;
      // Delete from Firebase msgs collection
      const msgRef = fbBase.collection("msgs").doc(payload.id);
      
      // Get the message first to find all users involved
      const msgDoc = await msgRef.get();
      if (!msgDoc.exists) {
        console.log("Message does not exist");
        return;
      }
      
      const msgData = msgDoc.data();
      const users = msgData.users || [];
      
      // Delete message from Firebase
      await msgRef.delete();
      
      // Delete from state
      if (s.msgs && s.msgs[payload.id]) {
        Vue.delete(s.msgs, payload.id);
      }
      
      // Remove message reference from all users involved using FieldValue.delete
      for (const userId of users) {
        const userRef = fbBase.collection("user").doc(userId);
        
        // Use FieldValue.delete() to remove only this specific message key
        await userRef.update({
          [`msgs.${payload.id}`]: fb.firestore.FieldValue.delete()
        });
        
        // Also update local state if user is loaded
        if (s.user && s.user[userId] && s.user[userId].msgs) {
          Vue.delete(s.user[userId].msgs, payload.id);
        }
      }
      
      return `*Deleted message* ${payload.id}`;
    },
    any: async (payload) => {
      const s = store().state;
      var itemRef = fbBase.collection(payload.type).doc(payload.id);
      
      // Check if user is admin
      const isAdmin = s.app.advanced.roles.admin &&
        s.app.advanced.roles.admin.members &&
        s.app.advanced.roles.admin.members.includes(s.auth.uid);
      
      // Get the item to check ownership
      const itemDoc = await itemRef.get();
      if (!itemDoc.exists) {
        console.error("Item does not exist:", payload.id);
        return;
      }
      const itemData = itemDoc.data();
      const isOwner = itemData.user === s.auth.uid;
      
      // Allow deletion if user is owner or admin
      if (!isOwner && !isAdmin) {
        console.error("User does not have permission to delete this item");
        return;
      }
      
      // If admin is deleting, get the original owner's user ref for cleanup
      const ownerUserId = isAdmin && !isOwner ? itemData.user : s.auth.uid;
      var userRef = fbBase.collection("user").doc(ownerUserId);
      
      return userRef
        .get()
        .then(async function (userData) {
          if (!userData.exists) {
            // If user doesn't exist, just delete the item
            return itemRef.delete().then(function () {
              store().dispatch("indexer", [{}, payload.id, payload.type]);
              if (s.manageData && s.manageData[payload.type]) {
                Vue.delete(s.manageData[payload.type], payload.id);
              }
              return "*Deleted* " + JSON.stringify(payload, null, 2);
            });
          }
          
          var userDataVal = userData.data();
          var userItems = [];
          if (userDataVal.items && userDataVal.items[payload.type]) {
            userDataVal.items[payload.type].forEach(function (item) {
              item !== payload.id && userItems.push(item);
            });
          }
          
          return itemRef.delete().then(function () {
            store().dispatch("indexer", [{}, payload.id, payload.type]);
            if (userDataVal.items) {
              userDataVal.items[payload.type] = userItems;
              userRef.update(userDataVal).then(async () => {
                // Only delete if manageData and the collection exist
                if (s.manageData && s.manageData[payload.type]) {
                  Vue.delete(s.manageData[payload.type], payload.id);
                }

                // Remove from ref collection if deleting a user
                if (payload.type === "user") {
                  if (s.ref && s.ref.name) {
                    Vue.delete(s.ref.name, payload.id);
                  }
                  if (s.ref && s.ref.image) {
                    Vue.delete(s.ref.image, payload.id);
                  }
                  fbBase.collection("ref").doc("name").set(s.ref.name);
                  fbBase.collection("ref").doc("image").set(s.ref.image);
                }
                return "*Deleted* " + JSON.stringify(payload, null, 2);
              });
            } else {
              // If user has no items array, just clean up manageData
              if (s.manageData && s.manageData[payload.type]) {
                Vue.delete(s.manageData[payload.type], payload.id);
              }
              return "*Deleted* " + JSON.stringify(payload, null, 2);
            }
          });
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },
  };
  return methods[
    Object.keys(methods).includes(payload.type) ? payload.type : "any"
  ](payload);
}

export { deleteAction as delete };

